import { GeneratedMap } from './TerrainGenerator';

/**
 * LevelFactory — converts a GeneratedMap into a Phaser-compatible Tiled JSON tilemap.
 *
 * The JSON format matches level1.json so it can be passed directly to:
 *   this.cache.tilemap.add(key, {
 *     format: Phaser.Tilemaps.Formats.TILED_JSON,
 *     data: json,
 *   });
 */
export class LevelFactory {
  buildTiledJSON(map: GeneratedMap): object {
    // Flatten tiles[row][col] into a 1-D array (row-major)
    const data: number[] = [];
    for (let r = 0; r < map.height; r++) {
      for (let c = 0; c < map.width; c++) {
        data.push(map.tiles[r][c]);
      }
    }

    return {
      compressionlevel: -1,
      height: map.height,
      infinite: false,
      layers: [
        {
          data,
          height: map.height,
          id: 1,
          name: 'ground',
          opacity: 1,
          type: 'tilelayer',
          visible: true,
          width: map.width,
          x: 0,
          y: 0,
        },
      ],
      nextlayerid: 2,
      nextobjectid: 1,
      orientation: 'orthogonal',
      renderorder: 'right-down',
      tiledversion: '1.10.0',
      tileheight: 32,
      tilesets: [
        {
          columns: 4,
          firstgid: 1,
          image: '../tilesets/tiles.png',
          imageheight: 128,
          imagewidth: 128,
          margin: 0,
          name: 'tiles',
          spacing: 0,
          tilecount: 16,
          tileheight: 32,
          tilewidth: 32,
          // Tile IDs are 0-indexed relative to the tileset (4 cols × 4 rows = 16 tiles).
          // See public/assets/tilesets/tileset.json for the full index mapping.
          tiles: [
            {
              id: 1,
              properties: [
                { name: 'destructible', type: 'bool', value: true },
              ],
            },
          ],
        },
      ],
      tilewidth: 32,
      type: 'map',
      version: '1.10',
      width: map.width,
    };
  }
}
